import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { getBlogPostBySlug } from '@/lib/content';
import type { BlogPost as BlogPostType } from '@/types/blog';
import NotFound from '@/pages/NotFound';
import { BlogPostTraditional } from './BlogPostTraditional';
import { BlogPostWithVideo } from './BlogPostWithVideo';

/**
 * BlogPost - Componente roteador que decide qual versão do post renderizar
 *
 * - Se post tem vídeo sincronizado (video.enabled = true): renderiza BlogPostWithVideo
 * - Caso contrário: renderiza BlogPostTraditional
 */
const BlogPost = () => {
  const { slug } = useParams<{ slug: string }>();
  const [post, setPost] = useState<BlogPostType | null>(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    if (!slug) {
      setNotFound(true);
      setLoading(false);
      return;
    }

    setLoading(true);
    getBlogPostBySlug(slug)
      .then(foundPost => {
        if (foundPost) {
          setPost(foundPost);
        } else {
          setNotFound(true);
        }
      })
      .catch(() => setNotFound(true))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) {
    return (
      <div className="container max-w-4xl py-12">
        <p className="text-center text-muted-foreground">Carregando...</p>
      </div>
    );
  }

  if (notFound || !post) {
    return <NotFound />;
  }

  // 🎬 Renderização condicional baseado no tipo de post
  if (post.video?.enabled) {
    return <BlogPostWithVideo post={post} />;
  }

  return <BlogPostTraditional post={post} />;
};

export default BlogPost;
